import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Data2Service } from '../../common/data2.service';
import { PostFiltersComponent } from '../post-filters/post-filters.component';
import { Company, Post, PostFilters } from '../post.model';

@Component({
	selector: 'app-post-in-list',
	templateUrl: './post-in-list.component.html',
	styleUrls: ['./post-in-list.component.css'],
})
export class PostInListComponent implements OnInit {
	loader = true;
	users: Array<any> = [];
	senders: Array<any> = [];
	posts: Array<any> = [];
	companies: Company[] = [];
	filters: PostFilters = {
		taskStatus: [],
		postSender: [],
		givenToPerson: [],
		createdBy: [],
		/*received: []*/
		received_from: null,
		received_to: null,
		recipient: [],
	};

	parameters = {
		tasksStatuses: [],
		postSenders: [],
		givenToPersons: [],
	};
	tableRows = [
		{ id: 'received', name: 'Data wpływu' },
		{ id: 'senderName', name: 'Nadawca' },
		{ id: 'givenToName', name: 'Przekazano do' },
		{ id: 'createdByName', name: 'Utworzone przez' },
		{ id: 'taskStatusName', name: 'Status' },
		{ id: 'taskLink', name: 'Zadanie', link: true },
	];

	private readonly filtersComponent: PostFiltersComponent;

	constructor(
		private readonly api: Data2Service,
		private readonly route: ActivatedRoute,
		protected router: Router,
	) {
		this.filtersComponent = new PostFiltersComponent(this.api, this.route, this.router);
	}

	async ngOnInit(): Promise<void> {
		const users = await this.api.getPromise<{ data: unknown[] }>('/users/');
		this.users = users.data;

		const companies = await this.api.getPromise<{ data: Company[] }>('/company/');
		this.companies = companies.data;

		const senders = await this.api.getPromise<{ data: unknown[] }>('/postSenders/');
		this.senders = senders.data;

		const tasksStatuses = await this.api.getPromise<{ data: unknown[] }>('/tasksStatuses/');
		this.parameters.tasksStatuses = tasksStatuses.data;

		this.loadData();
	}

	filtersOpen(): void {
		this.filtersComponent.filtersOpen();
	}

	filtersSelected(data: PostFilters): void {
		this.filters = data;

		if (!this.senders.length) {
			return;
		}

		this.loadData();
	}

	private getUserNameByKeyFromPost(
		key: string,
		pos: Post,
		userList: { id: string; name: string }[] = this.users,
	): string {
		return userList.find((user) => user.id === pos[key])?.name ?? '?';
	}

	private loadData(): void {
		this.loader = true;
		let parms: string = this.api.getChecked(this.filters, this.parameters);
		parms += '&taskStatus=' + this.filters.taskStatus;
		parms += '&sender=' + this.filters.postSender;
		parms += '&givenTo=' + this.filters.givenToPerson;
		this.api.get('/postIn/?' + parms, (result) => {
			result.data.forEach((pos) => {
				pos.givenToName = this.getUserNameByKeyFromPost('givenTo', pos);
				pos.createdByName = this.getUserNameByKeyFromPost('createdBy', pos);
				pos.senderName = this.getUserNameByKeyFromPost('sender', pos, this.senders);
				pos.taskLink = {
					link: '/task/' + pos.taskId,
					label: '(link)',
				};
			});
			this.posts = result.data;
			this.loader = false;
		});
	}
}
